import { useState, type ReactElement } from "react";

import { getToken, setToken } from "../api/client.js";

export const TokenInput = (): ReactElement => {
  const [token, setLocal] = useState<string>(getToken() ?? "");
  const [saved, setSaved] = useState<boolean>(false);

  const onSave = (): void => {
    setToken(token === "" ? null : token);
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };

  return (
    <div className="flex flex-col gap-1 text-xs text-slate-400">
      <label htmlFor="token-input" className="font-semibold uppercase tracking-wide">
        Bearer Token
      </label>
      <input
        id="token-input"
        type="password"
        value={token}
        onChange={(e) => setLocal(e.target.value)}
        className="rounded border border-slate-700 bg-slate-950 px-2 py-1 text-slate-100"
        placeholder="(empty = dev mode)"
      />
      <button
        type="button"
        onClick={onSave}
        className="rounded bg-slate-700 px-2 py-1 text-slate-100 hover:bg-slate-600"
      >
        {saved ? "Saved ✓" : "Save token"}
      </button>
    </div>
  );
};
